/* eslint-disable import/no-anonymous-default-export */
export default {
  header: {
    height: 80
  }
}
